import productCategoryModule from "./productCategoryModule"
import server from "../server"

productCategoryModule.service("productCategoryService", ["$http", function ($http) {

    this.findIncompatibleCandidates = (id) => {
        return $http.get(server.getServiceUrl("edition.product-category") + "incompatible/" + (id || ""))
            .then((response) => response.data)
    }
}])